"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectWorldCharacter = void 0;
const WorldCharacter_1 = require("../classes/WorldCharacter");
const definables_1 = require("definables");
const pixel_pigeon_1 = require("pixel-pigeon");
const selectWorldCharacter = (worldCharacterID) => {
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    (0, pixel_pigeon_1.goToLevel)(worldCharacter.tilemapID);
    (0, pixel_pigeon_1.lockCameraToEntity)(worldCharacter.entityID);
};
exports.selectWorldCharacter = selectWorldCharacter;
